import { css } from 'linaria';
import tokens from './tokens';
import { ShadowValues } from './types';

const boxShadowSmall = css`
    box-shadow: ${tokens.shadows.small};
`;

const boxShadowMedium = css`
    box-shadow: ${tokens.shadows.medium};
`;

const boxShadowLarge = css`
    box-shadow: ${tokens.shadows.large};
`;

const boxShadowXLarge = css`
    box-shadow: ${tokens.shadows.xlarge};
`;

const boxShadowFocusRing = css`
    box-shadow: ${tokens.shadows.focusRing};
`;

const boxShadowVariants: Record<ShadowValues, string> = {
    small: boxShadowSmall,
    medium: boxShadowMedium,
    large: boxShadowLarge,
    xlarge: boxShadowXLarge,
    focusRing: boxShadowFocusRing,
};

export default {
    boxShadowVariants,
};
